<template>
  <div class="data-park-basic">
    <breadcrumb :breadcrumb="breadcrumb" />

    <div style="display: flex;justify-content: space-between">
      <text-title mainTitle="阈值配置" />
      <div class="operationBox" v-if="permissionCodes.indexOf('033008001') !== -1">
        <a @click="modifyState = false" v-if="modifyState">修改</a><a @click="cancelChangeconfigDataInfo" v-if="!modifyState">取消</a><a @click="confirmChangeconfigDataInfo" v-if="!modifyState">确定</a>
      </div>
    </div>

    <form>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">A相电压最小值：</span>
        </div>
        <el-input type="text" v-model="configData.voltageMinA" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">V</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">A相电压最大值：</span>
        </div>
        <el-input type="text" v-model="configData.voltageMaxA" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">V</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">B相电压最小值：</span>
        </div>
        <el-input type="text" v-model="configData.voltageMinB" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">V</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">B相电压最大值：</span>
        </div>
        <el-input type="text" v-model="configData.voltageMaxB" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">V</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">C相电压最小值：</span>
        </div>
        <el-input type="text" v-model="configData.voltageMinC" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">V</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">C相电压最大值：</span>
        </div>
        <el-input type="text" v-model="configData.voltageMaxC" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">V</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">A相电流上限：</span>
        </div>
        <el-input type="text" v-model="configData.currentMaxA" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">A</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">B相电流上限：</span>
        </div>
        <el-input type="text" v-model="configData.currentMaxB" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">A</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">C相电流上限：</span>
        </div>
        <el-input type="text" v-model="configData.currentMaxC" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">A</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">A相温度上限：</span>
        </div>
        <el-input type="text" v-model="configData.temperatureMaxA" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">℃</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">B相温度上限：</span>
        </div>
        <el-input type="text" v-model="configData.temperatureMaxB" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">℃</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">C相温度上限：</span>
        </div>
        <el-input type="text" v-model="configData.temperatureMaxC" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">℃</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">房间温度最小值：</span>
        </div>
        <el-input type="text" v-model="configData.temperatureMin" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">℃</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">房间温度最大值：</span>
        </div>
        <el-input type="text" v-model="configData.temperatureMax" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">℃</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">房间湿度最小值：</span>
        </div>
        <el-input type="text" v-model="configData.humidityMin" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">%</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">房间湿度最大值：</span>
        </div>
        <el-input type="text" v-model="configData.humidityMax" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">%</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">负载率：</span>
        </div>
        <el-input type="text" v-model="configData.load" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">%</template>
        </el-input>
      </div>
<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <span class="line-text">电压正常值：</span>-->
<!--        </div>-->
<!--        <el-input type="text" v-model="configData.voltageMean" size="small" style="width: 280px" :disabled="modifyState">-->
<!--          <template slot="append">V</template>-->
<!--        </el-input>-->
<!--      </div>-->

<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <span class="line-text">电压过压：</span>-->
<!--        </div>-->
<!--        <el-input type="text" v-model="configData.voltageMore" size="small" style="width: 280px" :disabled="modifyState">-->
<!--          <template slot="append">%</template>-->
<!--        </el-input>-->
<!--      </div>-->

<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <span class="line-text">电压欠压：</span>-->
<!--        </div>-->
<!--        <el-input type="text" v-model="configData.voltageLess" size="small" style="width: 280px" :disabled="modifyState">-->
<!--          <template slot="append">%</template>-->
<!--        </el-input>-->
<!--      </div>-->

<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <span class="line-text">电流过流：</span>-->
<!--        </div>-->
<!--        <el-input type="text" v-model="configData.electricityMore" size="small" style="width: 280px" :disabled="modifyState">-->
<!--          <template slot="append">%</template>-->
<!--        </el-input>-->
<!--      </div>-->

<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <span class="line-text">过负荷：</span>-->
<!--        </div>-->
<!--        <el-input type="text" v-model="configData.overload" size="small" style="width: 280px" :disabled="modifyState">-->
<!--          <template slot="append">%</template>-->
<!--        </el-input>-->
<!--      </div>-->
    </form>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import { nError, nSuccess } from "../../../utils/notice";
import TextTitle from "../../../components/Text/TextTitle";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/SmartDetection";
import { bus } from "../../../utils/bus";
import UploadImgList from "../../../components/Input/UploadImgList";

export default {
  components: {
    UploadImgList,
    TextTitle,
    Breadcrumb
  },
  name: "smart-detection-alarm",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "配电监测",
          name: "smart-detection-over-view"
        },
        {
          value: "报警管理"
        }
      ],

      modifyState: true,
      configData: {
        voltageMinA: '',
        voltageMaxA: '',
        voltageMinB: '',
        voltageMaxB: '',
        voltageMinC: '',
        voltageMaxC: '',
        currentMaxA: '',
        currentMaxB: '',
        currentMaxC: '',
        temperatureMaxA: '',
        temperatureMaxB: '',
        temperatureMaxC: '',
        temperatureMin: '',
        temperatureMax: '',
        humidityMin: '',
        humidityMax: '',
        load: '',


        voltageMean: "",
        voltageMore: "",
        voltageLess: "",
        electricityMore: "",
        overload: ""
      }
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getEnergyThresholdConfig();
  },
  methods: {
    // 查询配置
    getEnergyThresholdConfig() {
      this.$axios
        .get(`${api.getEnergyThresholdConfig}`, {})
        .then(res => {
          let data = res.data.data;
          this.configData = data;
        })
        .catch(errorHandler("查询配置失败"));
    },

    // 取消修改
    cancelChangeconfigDataInfo() {
      this.modifyState = true;
      this.getEnergyThresholdConfig();
    },

    // 确认修改园区基本数据
    confirmChangeconfigDataInfo() {
      this.$axios
        .post(`${api.updateEnergyThresholdConfig}`, this.configData)
        .then(res => {
          this.modifyState = true;
          this.getEnergyThresholdConfig();
          nSuccess("修改成功");
        })
        .catch(errorHandler("修改失败"));
    }
  }
};
</script>

<style scoped>
.operationBox {
  margin: 20px 0 10px 0;
}
.operationBox a {
  font-size: 14px;
  float: right;
  margin-right: 30px;
  color: #00a0e6;
}
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
  vertical-align: sub;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form-line > div {
  margin-right: 20px;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 190px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 110px 0 140px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: space-between;
}
.newly2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  border: 1px dashed #d7d7d7;
  margin-right: 20px;
  position: relative;
}
.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}
.newly2 span:first-child {
  font-size: 36px;
  line-height: 120px;
  position: absolute;
  top: 15px;
}
.newly2 span:last-child {
  font-size: 14px;
  line-height: 50px;
  position: absolute;
  bottom: 0;
}
.upload2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload2 img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  bottom: 0;
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/view/SmartDetection/SmartDetectionAlarm/SmartDetectionAlarm.vue